export default __webpack_public_path__ + "static/media/mario-kart-calculator-sm.008c2de0.jpg";